import { Component } from '@angular/core';
import { LanguageService } from 'src/app/multi-language/language.service';

@Component({
  selector: 'app-nav-left',
  templateUrl: './nav-left.component.html',
  styleUrls: ['./nav-left.component.scss']
})
export class NavLeftComponent {
  username: string;
  constructor(
    // public cfLanguageService: CFLanguageService,
    public languageService: LanguageService,
    // private cfProduct: CfProductService,
    // public toastr: ToastrService,
    // private notificationService: NotificationService,
    // private cartService: CartService
  ) {

    this.username = JSON.parse(localStorage.getItem('user')).username || '';

    //multilanguage solutions
    // eslint-disable-next-line no-undef
    // this.langset = localStorage.getItem("lang")
    // this.getCFLanguage()
    // Find the language in languageList based on the stored langset
    // if (this.languageList) {
    //   // Find the language in languageList based on the stored langset
    //   const selectedLanguage = this.languageList
    //     .find((language) => language.code === this.langset)
    //     ?.name.toString();
    //   // Update siteLanguage if a matching language is found
    //   this.siteLanguage = selectedLanguage;
    // }
    // else {
    //   if (this.langset === 'en') {
    //     this.siteLanguage = 'English'
    //   }
    //   else {
    //     this.siteLanguage = 'Français'
    //   }
    // }
    // this.token = this.tfService.getToken();
    // this.group = this.tfService.getUserGroupsFromToken(this.token)
    // this.isStaf = this.tfService.getUserStaffFromToken(this.token)
    // /* eslint-disable eqeqeq */
    // if (this.group == 'admin') {
    //   this.isAdmin = true
    // }
    // else {
    //   this.isAdmin = false
    // }
    // this.loadFromLocalStorage();

  }
}
